
































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { namespace } from 'vuex-class';
import { AcgnPop } from '@acgn/herm/src/ui';
const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;
import { Cascader, DatePicker } from 'element-ui';

@Component({
  components: {
    AcgnPop,
    [DatePicker.name]: DatePicker,
    [Cascader.name]: Cascader
  }
})

/**
 * 指派
 */
export default class AcgnAppointDetail extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @ComicAction private getComicList: any; // 获取漫画项目列表
  @ComicGetter private comicList: any; // 漫画项目列表
  @ComicGetter private loadings: any; // 漫画loading
  private options: any[] = [
    {
      value: 'jzz',
      label: '监制组',
      children: [
        {
          value: 'zs',
          label: '张三',
        },
        {
          value: 'zs',
          label: '李四',
        },
        {
          value: 'zs',
          label: '王五',
        },
      ]
    },
    {
      value: 'zbz',
      label: '主笔组',
      children: [
        {
          value: 'zs',
          label: '赵刘',
        },
        {
          value: 'zs',
          label: '天起',
        },
        {
          value: 'zs',
          label: '王麻子',
        },
      ]
    },
    {
      value: 'ssz',
      label: '上色组',
      children: [
        {
          value: 'zs',
          label: '六天',
        },
        {
          value: 'zs',
          label: '王哈哈',
        },
        {
          value: 'zs',
          label: '张喝喝',
        },
      ]
    },
  ];
  private endDate: any = '';

  // 提交
  private submit() {
    this.$emit('update:visible', false);
  }

  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
  }
}
